import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { service } from '@ember/service';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import CButton from 'rise-ui/components/c-button.gjs';
import CompactQuickFilter from 'rise-ui/components/compact-quick-filter.gjs';
import fnx from 'rise-ui/helpers/fnx.js';

export default class TimeSeriesSelectionLineRecordComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;

  <template>
    <div class="c-time-series-selection-line c-time-series-selection-line-catalog c-lined__line"
      ...attributes
    >
      <div class="c-time-series-selection-line__wrapper">
        <span role="button"
          class="c-time-series-selection-line-actions dummy-button"
          {{on "click" (stopPropagation)}}
        >
          <span class="c-time-series-selection-line-actions__filter">
            <CompactQuickFilter
              @compactTitle="Quick Filter Catalog Record"
              @action={{fnx this.selectedLocations.quickFilterCatalog @record.id}}
            />
          </span>
        </span>
        <CButton
          @type="small muted"
          @external="true"
          class="c-time-series-selection-line-actions__record-link"
          @linkTo={{@linkToCatalog}}
        >Record Details</CButton>
        <span class="c-time-series-selection-line__type">Catalog Record</span>
        <span class="c-time-series-selection-line__label">
          {{~#if @record.generationEffort}}
            {{~@record.generationEffort~}}
          {{~else~}}
            {{@record.title}}
          {{~/if~}}
        </span>
      </div>
    </div>
  </template>
}
